export const KEYS = {
  PRESETS: 'us:image-adjust:presets',
  SHOW_BUTTON: 'us:image-adjust:show-button'
};

export const DEFAULT_SETTINGS = {
  [KEYS.PRESETS]: '[]',
  [KEYS.SHOW_BUTTON]: true
};

export const IMAGE_ENHANCEMENTS = Object.freeze({
  gamma: {
    min: 0,
    max: 3,
    step: 0.1,
    default: 1
  },
  contrast: {
    min: 75,
    max: 125,
    step: 0.1,
    default: 100
  },
  brightness: {
    min: 75,
    max: 125,
    step: 0.1,
    default: 100
  }
});
